import { render, staticRenderFns } from "./circle-editor.vue?vue&type=template&id=56e48406&scoped=true"
import script from "./circle-editor.vue?vue&type=script&lang=js"
export * from "./circle-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e48406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e48406')) {
      api.createRecord('56e48406', component.options)
    } else {
      api.reload('56e48406', component.options)
    }
    module.hot.accept("./circle-editor.vue?vue&type=template&id=56e48406&scoped=true", function () {
      api.rerender('56e48406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-button/circle-editor.vue"
export default component.exports